// extracted by mini-css-extract-plugin
export default {"letter":"Letter_letter__1wmEp","green":"Letter_green__6liH+","yellow":"Letter_yellow__Vcsuv","grey":"Letter_grey__sXycB"};